<template>
    <AppLayout>
        <div class="page">
            <div class="flow">
                <div class="flow-head">
                    <div class="flow-title">使用流程</div>
                    <div class="flow-sub">通过云链，您可以快速组建专业团队，高效完成项目</div>
                </div>

                <div class="flow-panel">
                    <div class="flow-steps">
                        <!-- Step 1 -->
                        <section class="step">
                            <div class="step-cap">
                                <img class="cap-dot" src="@/assets/Frame@2x.png" alt="" />
                                <div class="cap-text">第一步：甲方发布任务</div>
                            </div>
                            <!-- <img class="step-shotimg" src="@/assets/Frame3.png" alt="" /> -->
                            <div class="step-shot shot1 shot--form">
                                <div class="shot-chrome">
                                    <div class="shot-dots">
                                        <span class="d red"></span>
                                        <span class="d yellow"></span>
                                        <span class="d green"></span>
                                    </div>
                                    <div class="shot-tip">官网地址</div>
                                </div>

                                <div class="shot-body">
                                    <div class="mini-form">
                                        <div class="mini-row">
                                            <div class="mini-l">任务名称</div>
                                            <div class="mini-ipt">品牌LOGO设计</div>
                                        </div>
                                        <div class="mini-row">
                                            <div class="mini-l">预算范围</div>
                                            <div class="mini-ipt muted">请输入预算</div>
                                        </div>
                                        <div class="mini-row">
                                            <div class="mini-l">截止日期</div>
                                            <div class="mini-ipt muted">选择截止日期</div>
                                        </div>
                                        <div class="mini-row">
                                            <div class="mini-l">用途</div>
                                            <div class="mini-ipt muted">选择类型</div>
                                        </div>

                                        <div class="mini-btn">
                                            <el-button type="success" size="small" round>提交</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Step 2 -->
                        <section class="step">
                            <div class="step-cap">
                                <img class="cap-dot" src="@/assets/Frame@2x(1).png" alt="" />
                                <div class="cap-text">第二步：乙方报价</div>
                            </div>

                            <div class="step-shot shot2 shot--quote">
                                <div class="shot-chrome">
                                    <div class="shot-dots">
                                        <span class="d red"></span>
                                        <span class="d yellow"></span>
                                        <span class="d green"></span>
                                    </div>
                                    <div class="shot-tip">官网地址</div>
                                </div>

                                <div class="shot-body">
                                    <div class="mini-form">
                                        <div class="mini-row">
                                            <div class="mini-l">任务名称</div>
                                            <div class="mini-ipt">品牌LOGO设计</div>
                                        </div>
                                        <div class="mini-row">
                                            <div class="mini-l">我的报价</div>
                                            <div class="mini-ipt muted">请输入</div>
                                        </div>
                                        <div class="mini-row">
                                            <div class="mini-l">预计工期</div>
                                            <div class="mini-ipt muted">请输入</div>
                                        </div>

                                        <div class="mini-btn">
                                            <el-button type="success" size="small" round>提交</el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Step 3 -->
                        <section class="step">
                            <div class="step-cap">
                                <img class="cap-dot" src="@/assets/Frame@2x(2).png" alt="" />
                                <div class="cap-text">第三步：甲方查看并选择合适人员后联系平台</div>
                            </div>

                            <div class="step-shot shot3 shot--list">
                                <div class="shot-chrome">
                                    <div class="shot-dots">
                                        <span class="d red"></span>
                                        <span class="d yellow"></span>
                                        <span class="d green"></span>
                                    </div>
                                    <div class="shot-tip">官网地址</div>
                                </div>

                                <div class="shot-body">
                                    <div class="mini-list">
                                        <div v-for="i in 3" :key="i" class="mini-card">
                                            <div class="mini-avatar"></div>
                                            <div class="mini-info">
                                                <div class="mini-name">李设计师</div>
                                                <div class="mini-star">
                                                    <span class="star">★</span>
                                                    <span class="score">4.8</span>
                                                </div>
                                            </div>

                                            <div class="mini-right">
                                                <div class="mini-price">￥1500</div>
                                                <div class="mini-tag">7天交付</div>
                                                <div class="mini-actions">
                                                    <span class="mini-act">查看详情</span>
                                                    <span class="mini-act primary">选 择</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Step 4 -->
                        <section class="step">
                            <div class="step-cap">
                                <img class="cap-dot" src="@/assets/Frame@2x(3).png" alt="" />
                                <div class="cap-text">第四步：合作成功，确认开始</div>
                            </div>

                            <div class="step-shot shot4 shot--confirm">
                                <div class="shot-chrome">
                                    <div class="shot-dots">
                                        <span class="d red"></span>
                                        <span class="d yellow"></span>
                                        <span class="d green"></span>
                                    </div>
                                    <div class="shot-tip">官网地址</div>
                                </div>

                                <div class="shot-body">
                                    <div class="mini-center">
                                        <img class="mini-badge" src="@/assets/Frame@2x(3).png" alt="" />
                                        <div class="mini-h">合作确认</div>
                                        <div class="mini-p">恭喜!您已成功匹配到合适的人才</div>

                                        <div class="mini-kv">
                                            <div class="mini-kv2" style="">
                                                <div class="kv-row">
                                                    <div class="k">任务名称</div>
                                                    <div class="v">品牌LOGO设计</div>
                                                </div>
                                                <div class="kv-row">
                                                    <div class="k">合作方</div>
                                                    <div class="v">王设计师</div>
                                                </div>
                                                <div class="kv-row">
                                                    <div class="k">报价金额</div>
                                                    <div class="v">￥1500</div>
                                                </div>
                                                <div class="kv-row">
                                                    <div class="k">交付时间</div>
                                                    <div class="v">2026-01-01</div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        <!-- Step 5 -->
                        <section class="step">
                            <div class="step-cap">
                                <img class="cap-dot" src="@/assets/Frame 427320390@2x.png" alt="" />
                                <div class="cap-text">第五步：确认完成</div>
                            </div>

                            <div class="step-shot shot shot--done">
                                <div class="shot-chrome">
                                    <div class="shot-dots">
                                        <span class="d red"></span>
                                        <span class="d yellow"></span>
                                        <span class="d green"></span>
                                    </div>

                                    <div class="shot-tip">官网地址</div>
                                </div>

                                <div class="shot-body">
                                    <div class="mini-center">

                                        <img class="mini-badge" src="@/assets/Frame 427320390@2x.png" alt="" />
                                        <div class="mini-h">项目完成</div>
                                        <div class="mini-p">恭喜!您已成功匹配到合适的人才</div>

                                        <div class="mini-divider"></div>

                                        <div class="mini-block">
                                            <div class="b-title">项目总结</div>
                                            <div class="b-text">
                                                已完成品牌logo设计，包含三个不同风格的方案，每个方案都提供了AI、EPS、PNG和JPG格式。所有文件均已打包上传，可供下载。
                                            </div>
                                        </div>

                                        <div class="mini-rate">
                                            <div class="r-title">评分与反馈</div>
                                            <div class="r-stars">
                                                <span class="s on">★</span><span class="s on">★</span><span
                                                    class="s on">★</span><span class="s on">★</span><span
                                                    class="s on">★</span>
                                                <span class="r-score">4.8</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </AppLayout>
</template>

<script setup>
import AppLayout from '@/layouts/AppLayout.vue'
</script>

<style lang="scss" scoped>
.page {
    // max-width: 1200px;
    margin: 0 auto;
    padding: 149px 240px 64px;
    background: #fff;
}

.flow {
    // padding-top: 26px;
}

.flow-head {
    text-align: center;
    margin-bottom: 32px;
}

.flow-title {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 44px;
    color: #3D3D3D;
}

.flow-sub {
    margin-top: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 24px;
    color: rgba(61, 61, 61, 0.7);
}

.flow-panel {
    width: 100%;
    padding: 82px 0 82px;
    border-radius: 12px;
    background: #fff;
    background: #F9F9F9;
    border-radius: 0px 0px 0px 0px;
}

.flow-steps {
    width: 760px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 80px;
}

/* 每一段：标题 + 截图块 */
.step {
    display: flex;
    flex-direction: column;
    align-items: center;
    // justify-content: ;
}

.step-cap {
    display: inline-flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 48px;
}

.step-shotimg {
    width: 669px;
    height: 430px;
}

.cap-dot {
    width: 40px;
    height: 40px;
    // border-radius: 50%;
    // border: 1px solid #4caf50;
    // display: inline-flex;
    // align-items: center;
    // justify-content: center;
    // background: #effbf0;
}


.cap-text {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 24px;
    color: #333333;
}

/* 截图卡片：仿浏览器窗口 + 渐变描边 */
.shot1 {
    width: 669px;
    // height: 430px;
    background: linear-gradient(90deg, #FFF7EC 0%, #E7E4FF 100%);
    box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 10px solid;
    border-image: linear-gradient(90deg, #FFF1DF, #DFDDFF) 10 10;
}

.shot2 {
    width: 669px;
    // height: 353px;
    background: linear-gradient(90deg, #F0F5FF 0%, #FFF0E4 100%);
    box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 10px solid;
    border-image: linear-gradient(90deg, #DCE8FF, #FFE4CF) 10 10;
}

.shot3 {
    width: 669px;
    // height: 353px;
    background: linear-gradient(90deg, #FFF7EC 0%, #E7E4FF 100%);
    box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 10px solid;
    border-image: linear-gradient(90deg, #FFF1DF, #DFDDFF) 10 10;
}

.shot4 {
    width: 669px;
    // height: 396px;
    background: linear-gradient(90deg, #FFF1ED 0%, #EDFEFF 100%);
    box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 10px solid;
    border-image: linear-gradient(90deg, rgba(255, 230, 223, 1), rgba(221, 253, 255, 1)) 10 10;
}

.shot {
    width: 669px;
    // height: 396px;
    background: linear-gradient(90deg, #FFF7EC 0%, #E7E4FF 100%);
    box-shadow: 0px 8px 16px 0px rgba(9, 58, 11, 0.1);
    border-radius: 12px 12px 12px 12px;
    border: 10px solid;
    border-image: linear-gradient(90deg, #FFF1DF, #DFDDFF) 10 10;
}

.shot-chrome,
.shot-body {
    position: relative;
    z-index: 1;
}

.shot-chrome {

    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 14px;
}

.shot-dots {
    display: inline-flex;
    align-items: center;
    gap: 6px;

    .d {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        display: inline-block;
    }

    .red {
        background: #EF4444;
    }

    .yellow {
        background: #EAB308;
    }

    .green {
        background: #22C55E;
    }
}

.shot-tip {
    font-size: 12px;
    color: #4CAF50;
    font-weight: 400;
}

.shot-body {
    padding: 0px 14px 14px;
}

/* ===== mini form ===== */
.mini-form {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.mini-row {
    display: grid;
    // grid-template-columns: 86px 1fr;
    gap: 10px;
    align-items: center;
}

.mini-l {
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
}

.mini-ipt {
    height: 36px;
    background: #FFFFFF;
    border-radius: 8px 8px 8px 8px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
    line-height: 36px;
    padding-left: 8px;
}

.muted {
    color: #D0D0D0;
}

.mini-btn {
    margin-top: 6px;
    display: flex;
    justify-content: flex-start;

    :deep(.el-button) {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 92px;
        height: 40px;
        background: #4CAF50;
        border-radius: 8px 8px 8px 8px;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
    }
}

/* ===== step3 list ===== */
.mini-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.mini-card {
    width: 621px;
    height: 109px;
    background: rgba(255, 255, 255, 0.3);
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #4CAF50;

    padding: 16px;
    display: grid;
    grid-template-columns: 36px 1fr auto;
    gap: 18px;
    background: rgba(255, 255, 255, 0.3);
}

.mini-avatar {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: radial-gradient(circle at 30% 30%, #ffd3d3, #c6c6c6);
    // border: 1px solid #eee;
}

.mini-name {
    font-weight: 500;
    font-size: 18px;
    color: #000000;
}

.mini-star {
    margin-top: 4px;
    font-weight: 400;
    font-size: 16px;
    color: #000000;

    .star {
        color: #FACC15;
        margin-right: 4px;
    }

    .score {
        color: #666;
    }
}

.mini-right {
    text-align: right;
    min-width: 120px;
}

.mini-price {
    font-weight: 500;
    font-size: 16px;
    color: #FF2525;
}

.mini-tag {
    margin-top: 4px;
    font-weight: 400;
    font-size: 12px;
    color: rgba(51, 51, 51, 0.7);
}

.mini-actions {
    margin-top: 8px;
    display: inline-flex;
    gap: 8px;
    justify-content: flex-end;
}

.mini-act {
    padding: 0 8px;
    line-height: 28px;
    height: 28px;
    background: #E8FFE9;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #4CAF50;
    font-weight: 500;
    font-size: 12px;
    color: #4CAF50;

    &.primary {
        border-color: #4caf50;
        background: #4caf50;
        color: #fff;
    }
}

/* ===== center blocks (step4/5) ===== */
.mini-center {
    padding: 10px 6px 6px;
    text-align: center;
}

.mini-badge {
    width: 68px;
    height: 68px;
    margin-bottom: 18px;
    // border-radius: 50%;
    // margin: 0 auto 10px;
    // background: #eaf8ea;
    // border: 1px solid #bfe8c2;
    // display: flex;
    // align-items: center;
    // justify-content: center;

    .badge-icon {
        font-size: 18px;
        color: #2f9f35;
        font-weight: 800;
        line-height: 1;
    }

    &.ok {
        background: #eaf8ea;
    }
}

.mini-h {
    font-weight: 500;
    font-size: 20px;
    color: #333333;
}

.mini-p {
    font-weight: 400;
    font-size: 14px;
    color: rgba(51, 51, 51, 0.7);
}

.mini-kv {
    margin-top: 14px;
    // padding-top: 16px;
    border-top: 1px solid #E6E6E6;
    text-align: left;
}

.mini-kv2 {
    margin-top: 14px;
    background: rgba(255, 255, 255, 0.6);
    padding: 12px 16px;
}

.kv-row {
    display: grid;
    grid-template-columns: 72px 1fr;
    padding: 4px 0;
    font-size: 18px;


    .k {
        color: #727272;
    }

    .v {
        color: #727272;
        text-align: right;
    }
}

.mini-divider {
    margin: 14px 0;
    height: 1px;
    background: #E6E6E6;
}

.mini-block {
    text-align: left;
    padding: 0 4px;

    .b-title {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        margin-bottom: 12px;
    }

    .b-text {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
    }
}

.mini-rate {
    margin-top: 18px;
    text-align: left;
    padding: 0 4px;

    .r-title {
        font-weight: 400;
        font-size: 15px;
        color: #000000;
        margin-bottom: 8px;
    }

    .r-stars {
        display: inline-flex;
        align-items: center;
        gap: 2px;

        .s {
            font-size: 16px;
            color: #FACC15;

            &.on {
                color: #FACC15;
            }
        }

        .r-score {
            margin-left: 8px;
            font-weight: 400;
font-size: 16px;
color: #000000;
        }
    }
}

/* 渐变色微调：不同步骤略有差异（贴近 UI 的色感） */
.shot--form::before {
    background: linear-gradient(90deg, rgba(255, 216, 130, 0.85), rgba(186, 160, 255, 0.85));
}

.shot--quote::before {
    background: linear-gradient(90deg, rgba(139, 197, 255, 0.85), rgba(255, 206, 146, 0.85));
}

.shot--list::before {
    background: linear-gradient(90deg, rgba(255, 212, 136, 0.85), rgba(182, 164, 255, 0.85));
}

.shot--confirm::before {
    background: linear-gradient(90deg, rgba(255, 210, 140, 0.85), rgba(176, 252, 231, 0.85));
}

.shot--done::before {
    background: linear-gradient(90deg, rgba(255, 210, 140, 0.85), rgba(183, 162, 255, 0.85));
}

/* 响应式：移动端缩小截图宽度 */
@media (max-width: 860px) {
    .flow-steps {
        width: 100%;
        padding: 0 8px;
    }

    .shot {
        width: 100%;
        max-width: 520px;
    }
}
</style>